import type { Locale } from '@xdocs/i18n';

/**
 * STOP-GAP local catalog for the `adminInbox:` scope (F53), following the
 * `shares:`/`search:` precedent — see `apps/web/src/routes/shares/shares.i18n.ts`.
 * NOT a second i18n runtime (E18/§13.3 ban); `packages/i18n/**` is outside
 * this task's ownership.
 *
 * OPEN ISSUE: fold into `packages/i18n/src/catalogs/{en,ro}/admin.json`.
 */
const en = {
  'page.title': 'Contact / DMCA inbox',
  'page.description': 'Triage, respond to, and close contact-form and DMCA takedown submissions.',
  'tabs.all': 'All',
  'tabs.contact': 'Contact',
  'tabs.dmca': 'DMCA',
  'filter.status.label': 'Status',
  'filter.status.all': 'All statuses',
  'status.new': 'New',
  'status.in_progress': 'In progress',
  'status.handled': 'Handled',
  'type.contact': 'Contact',
  'type.dmca': 'DMCA',
  'list.column.submitter': 'Submitter',
  'list.column.type': 'Type',
  'list.column.subject': 'Subject',
  'list.column.status': 'Status',
  'list.column.received': 'Received',
  'list.empty.title': 'Inbox is empty',
  'list.empty.description': 'New contact and DMCA submissions will show up here.',
  'list.error.title': "Couldn't load the inbox.",
  'list.noResults.title': 'No submissions match “{query}”',
  'list.searchLabel': 'Search submissions',
  'list.searchPlaceholder': 'Search by name, email, or subject…',
  'detail.title': 'Submission',
  'detail.field.from': 'From',
  'detail.field.subject': 'Subject',
  'detail.field.message': 'Message',
  'detail.field.received': 'Received',
  'detail.dmca.hint': 'DMCA takedown — check the message for the targeted share/URL, then use Assets to unpublish or remove.',
  'detail.dmca.openAssets': 'Open Assets',
  'detail.action.assign': 'Assign to me',
  'detail.action.respond': 'Respond',
  'detail.action.close': 'Close',
  'detail.response.label': 'Reply',
  'detail.response.placeholder': 'Write a reply — sent to the submitter by email…',
  'detail.response.send': 'Send reply',
  'toast.assigned.action': 'Assigned',
  'toast.responded.action': 'Replied to',
  'toast.closed.action': 'Closed',
  'live.newSubmission': 'A new submission just arrived.',
} as const;

const ro = {
  'page.title': 'Contact / sesizări DMCA',
  'page.description': 'Triază, răspunde și închide formularele de contact și sesizările DMCA.',
  'tabs.all': 'Toate',
  'tabs.contact': 'Contact',
  'tabs.dmca': 'DMCA',
  'filter.status.label': 'Stare',
  'filter.status.all': 'Toate stările',
  'status.new': 'Nou',
  'status.in_progress': 'În lucru',
  'status.handled': 'Rezolvat',
  'type.contact': 'Contact',
  'type.dmca': 'DMCA',
  'list.column.submitter': 'Expeditor',
  'list.column.type': 'Tip',
  'list.column.subject': 'Subiect',
  'list.column.status': 'Stare',
  'list.column.received': 'Primit',
  'list.empty.title': 'Căsuța este goală',
  'list.empty.description': 'Noile mesaje de contact și sesizări DMCA vor apărea aici.',
  'list.error.title': 'Nu am putut încărca mesajele.',
  'list.noResults.title': 'Niciun mesaj nu se potrivește cu „{query}”',
  'list.searchLabel': 'Caută mesaje',
  'list.searchPlaceholder': 'Caută după nume, email sau subiect…',
  'detail.title': 'Mesaj',
  'detail.field.from': 'De la',
  'detail.field.subject': 'Subiect',
  'detail.field.message': 'Mesaj',
  'detail.field.received': 'Primit',
  'detail.dmca.hint': 'Sesizare DMCA — verifică mesajul pentru distribuirea/URL-ul vizat, apoi folosește Assets pentru a retrage sau elimina.',
  'detail.dmca.openAssets': 'Deschide Assets',
  'detail.action.assign': 'Preia',
  'detail.action.respond': 'Răspunde',
  'detail.action.close': 'Închide',
  'detail.response.label': 'Răspuns',
  'detail.response.placeholder': 'Scrie un răspuns — trimis expeditorului prin email…',
  'detail.response.send': 'Trimite răspunsul',
  'toast.assigned.action': 'Preluat',
  'toast.responded.action': 'Răspuns trimis către',
  'toast.closed.action': 'Închis',
  'live.newSubmission': 'A sosit un mesaj nou.',
} as const;

export const ADMIN_INBOX_CATALOG: Record<Locale, Record<AdminInboxCatalogKey, string>> = { en, ro };
export type AdminInboxCatalogKey = keyof typeof en;
